import { ModalCollection } from '~/constants'
import { AccountTabs } from '~/constants/account'
import { CMS_API } from '~/configs/api'
import { getPromotionBanners as getPermanentBanners, eventBanner, eventBanner500K } from '~resources/promotion'

import { useApi } from '~/composables/common/use-api'
import { useModal } from '~/composables/common/use-modal'
import { useLogin } from '~/composables/account/use-login'

export function useInstruction() {
  const config = useRuntimeConfig()
  const { request } = useApi()
  const { isMobile } = useDevice()
  const route = useRoute()
  const { openModal } = useModal()
  const { isLogged } = useLogin()
  const router = useRouter()

  const currentIndex = ref()
  const availablePromotionsDetail = ref<number>()
  const promotionDetail = ref('')
  const loading = ref(false)
  const isShowDetaiPromotion = ref(false)

  const promotionBanners = computed(() => {
    const permanentBanners = getPermanentBanners(config.public.INDIRECT_BRAND2_NAME)
    let allBanners = permanentBanners
    if (config.public.EVENT_TIME) {
      allBanners = [eventBanner, ...permanentBanners]
    }
    if (config.public.IS_500K_EVENT_ENABLED) {
      allBanners = [eventBanner500K, ...allBanners]
    }
    return allBanners
  })

  const fetchPromotionDetail = async (slug: string | undefined): Promise<void> => {
    try {
      loading.value = true
      if (typeof slug === 'string') {
        const params = { slug }
        const { data } = await request(CMS_API.POST_DETAIL, { params })
        if (data?.length) {
          promotionDetail.value = data[0]?.post?.content
        }
      }
    } finally {
      loading.value = false
    }
  }

  const getPromotion = (index?: number): void => {
    if (!isLogged.value) {
      openModal(ModalCollection.LOGIN_AND_SIGN_UP, ModalCollection.LOGIN, true)
      return
    }
    const promotion = promotionBanners.value[index ?? currentIndex.value]
    if (promotion.footer.button?.link) {
      void router.push(promotion.footer.button?.link)
      return
    }
    if (isMobile) {
      availablePromotionsDetail.value = promotion.packageId
    }
    if (availablePromotionsDetail.value) {
      const depositSlug = AccountTabs.DEPOSIT as string
      void router.push(`${depositSlug}&promotion=${availablePromotionsDetail.value}`)
    }
  }

  watch(
    () => route.query.tab,
    slug => {
      if (typeof slug === 'string') {
        promotionDetail.value = ''
        isShowDetaiPromotion.value = true
        currentIndex.value = promotionBanners.value.findIndex(item => item.slug === slug)
        const availablePromotions = promotionBanners.value[currentIndex.value]
        availablePromotionsDetail.value = availablePromotions?.packageId
        void fetchPromotionDetail(slug)
        return
      }
      isShowDetaiPromotion.value = false
      currentIndex.value = 0
      availablePromotionsDetail.value = promotionBanners.value[0].packageId
    },
    { immediate: true }
  )

  return {
    promotionBanners,
    currentIndex,
    promotionDetail,
    availablePromotionsDetail,
    loading,
    isShowDetaiPromotion,
    getPromotion,
    fetchPromotionDetail
  }
}
